import { GrantsEntities } from '@/types/pages/api/grants/grants-entities';

const assetLink = (assetCode: string, assets: GrantsEntities['ecosystemsById']): string => {
    return assets[assetCode] ? `/price/${assets[assetCode]!.code.toLowerCase()}` : `/price/${assetCode.toLowerCase()}`;
};

export default assetLink;
